export const QUERIES = {
  onboarding: 'onboarding',
};
